<template>
  <section class="page-empresa page-layout">

    <!-- Page Title -->
    <div class="page-layout__container page-title">
      <div class="container">
        <div class="row page-layout__content flex-column">
          <h1>Nuestro Equipo</h1>
          <p class="mt-3">
            En TORBEL nos caracterizamos por ser apasionados y comprometidos con
            lo que hacemos, ofreciendo productos y servicios que superen las
            expectativas del cliente, utilizando nuestro conocimiento y
            experiencia, con sentido de urgencia. <br /><br />

            Valores que marcan nuestro camino y actuar son:
            <strong
              >respeto, tolerancia, igualdad, ética, eficiencia, confianza y
              motivación.</strong
            >
          </p>
        </div>
      </div>
    </div>

    <!-- Team single picture -->
    <section class="team">
      <div class="container">
        <div class="team__grid">
          <div
            class="team__member"
            id="ruben"
            v-scroll="handleScroll"
            data-scroll-class="animated slideInUp "
            data-scroll-button-distance="400"
            data-scroll-once="true"
          >
            <figure>
              <img
                src="../assets/images/ruben.png"
                alt="Foto de Ruben Gomez Pou"
              />
              <figcaption class="team__caption">
                <h5 class="team__name">Ruben Gómez Pou</h5>
                <p class="team__role">
                  Ing. Civil con Máster en Administración de Empresas y
                  Post-grado en Administración de la Construcción. Amplia
                  experiencia en la industria del petróleo y proyectos de
                  construcción, más de 15 años en desarrollo y evaluación
                  ambiental de proyectos, habiendo ocupado puestos en
                  importantes empresas multinacionales.
                </p>
              </figcaption>
            </figure>
          </div>

          <div
            class="team__member"
            id="diana"
            v-scroll="handleScroll"
            data-scroll-class="animated slideInUp "
            data-scroll-button-distance="400"
            data-scroll-once="true"
          >
            <figure>
              <img
                src="../assets/images/diana.png"
                alt="Foto de Diana Beltran"
              />
              <figcaption class="team__caption">
                <h5 class="team__name">Diana Beltrán Alonso</h5>
                <p class="team__role">
                  Mercadóloga con amplios conocimientos en la ejecución y
                  análisis de proyectos de investigación. Experiencia en
                  planificación, coordinación y seguimiento de proyectos, así
                  como en la gestión de estratégica de clientes.
                </p>
              </figcaption>
            </figure>
          </div>

          <div
            class="team__member"
            id="jose"
            v-scroll="handleScroll"
            data-scroll-class="animated slideInUp "
            data-scroll-button-distance="400"
            data-scroll-once="true"
          >
            <figure>
              <img
                src="../assets/images/jose.png"
                alt="Foto de Jose Gomez Pou"
              />
              <figcaption class="team__caption">
                <h5 class="team__name">José Gómez Pou</h5>
                <p class="team__role">
                  Ing. Electrónico y de Comunicaciones con Máster en
                  Administración de Empresas, y especialidad en logística,
                  producción y cadena de suministro. Amplia experiencia en la
                  industria de iluminación y de electricidad, habiendo ocupado
                  puestos en importantes empresas multinacionales.
                </p>
              </figcaption>
            </figure>
          </div>

          <div
            class="team__member"
            id="johanna"
            v-scroll="handleScroll"
            data-scroll-class="animated slideInUp "
            data-scroll-button-distance="400"
            data-scroll-once="true"
          >
            <figure>
              <img
                src="../assets/images/johanna.png"
                alt="Foto de Johanna López"
              />
              <figcaption class="team__caption">
                <h5 class="team__name">Johanna López Taveras</h5>
                <p class="team__role">
                  Licenciada en Administración de Empresas, con amplia
                  experiencia en el manejo, gestión y atención a clientes.
                  Conocimientos en el mercado de combustibles, compras, crédito
                  y cobros, habiendo prestado servicios en importantes empresas
                  multinacionales.
                </p>
              </figcaption>
            </figure>
          </div>

          <div
            class="team__member"
            id="kania"
            v-scroll="handleScroll"
            data-scroll-class="animated slideInUp "
            data-scroll-button-distance="400"
            data-scroll-once="true"
          >
            <figure>
              <img
                src="../assets/images/kania.png"
                alt="Photo of Kania Castellanos"
              />
              <figcaption class="team__caption">
                <h5 class="team__name">Kania Castellanos</h5>
                <p class="team__role">
                  Ingeniera Industrial, con Maestría en Alta Gerencia y más de 10
                  años de experiencia en gestión ambiental y sostenibilidad.
                  Especialista en elaboración de informes ambientales, gestión
                  del cambio y fortalecimiento de culturas organizacionales
                  orientadas al cumplimiento y la eficiencia.
                </p>
              </figcaption>
            </figure>
          </div>

          <div
            class="team__member"
            id="rosanna"
            v-scroll="handleScroll"
            data-scroll-class="animated slideInUp "
            data-scroll-button-distance="400"
            data-scroll-once="true"
          >
            <figure>
              <img
                src="../assets/images/rosanna.png"
                alt="Photo of Rosanna Rojas Gutierrez"
                style="object-position: 50% 90%;"
              />
              <figcaption class="team__caption">
                <h5 class="team__name">Rosanna Rojas Gutierrez</h5>
                <p class="team__role">
                  Licenciada en Comunicación Social con más de 10 años de
                  experiencia en ventas, servicio al cliente y asistencia
                  administrativa. Especialista en la gestión y fidelización de
                  clientes, el manejo de tareas simultáneas y la organización
                  eficiente de procesos para garantizar operaciones fluidas y
                  resultados consistentes.
                </p>
              </figcaption>
            </figure>
          </div>

          <div
            class="team__member"
            id="guarino"
            v-scroll="handleScroll"
            data-scroll-class="animated slideInUp "
            data-scroll-button-distance="400"
            data-scroll-once="true"
          >
            <figure>
              <img
                src="../assets/images/perez2.png"
                alt="Foto de Guarino Pérez"
              />
              <figcaption class="team__caption">
                <h5 class="team__name">Guarino Pérez</h5>
                <p class="team__role">
                  45 años de experiencia en logística e instalación de letreros
                  para el sector empresarial y el sector de estaciones de
                  combustible. Conocimiento probado en el manejo y aplicación de
                  materiales para la fabricación de letreros luminosos de
                  exterior de gran escala y fachadas.
                </p>
              </figcaption>
            </figure>
          </div>

          <div
            class="team__member"
            id="alejandro"
            v-scroll="handleScroll"
            data-scroll-class="animated slideInUp "
            data-scroll-button-distance="400"
            data-scroll-once="true"
          >
            <figure>
              <img
                src="../assets/images/josechabebe.png"
                alt="Foto de Alejandro Chabebe"
              />
              <figcaption class="team__caption">
                <h5 class="team__name">Alejandro Chabebe</h5>
                <p class="team__role">
                  Ingeniero Civil con más de 17 años de experiencia en el sector
                  de la construcción. Habiendo trabajado en macro proyectos
                  civiles y de mantenimiento, especializado en infraestructura
                  de estaciones de combustibles. Amplia experiencia en
                  logística, materiales e instalación de letreros luminosos de
                  exterior.
                </p>
              </figcaption>
            </figure>
          </div>

          <div
            class="team__member"
            id="eusebio"
            v-scroll="handleScroll"
            data-scroll-class="animated slideInUp "
            data-scroll-button-distance="400"
            data-scroll-once="true"
          >
            <figure>
              <img
                src="../assets/images/perez1.png"
                alt="Foto de Eusebio Pérez"
              />
              <figcaption class="team__caption">
                <h5 class="team__name">Eusebio Pérez</h5>
                <p class="team__role">
                  Ingeniero Civil con más de 30 años de experiencia en el sector
                  de la construcción. Amplia experiencia en logística,
                  fabricación e instalación de letreros luminosos exteriores.
                </p>
              </figcaption>
            </figure>
          </div>


        </div>
      </div>
    </section>

    <!-- Ours Numbers -->
    <section class="our-numbers">
      <div class="container-fluid">
        <div class="row our-numbers--title">
          <h1>Torbel en números</h1>
        </div>

        <div class="row">
          <ul class="list-a fading">
            <div class="li col">
              <li class="fading">
                <span
                  v-scroll="handleScroll"
                  data-scroll-class="animated heartBeat"
                  data-scroll-button-distance="400"
                  data-scroll-once="true"
                  data-scroll-count-to="548"
                >
                  548
                </span>
                Proyectos completados exitosamente
              </li>
            </div>
            <div class="li col">
              <li class="fading">
                <span
                  v-scroll="handleScroll"
                  data-scroll-class="animated jackInTheBox"
                  data-scroll-button-distance="400"
                  data-scroll-once="true"
                  data-scroll-count-to="20"
                >
                  20
                </span>
                Años de experiencia en el sector ambiental
              </li>
            </div>
            <div class="li col">
              <li class="fading">
                <span
                  v-scroll="handleScroll"
                  data-scroll-class="animated heartBeat"
                  data-scroll-button-distance="400"
                  data-scroll-once="true"
                  data-scroll-count-to="3"
                >
                  3
                </span>
                Plantas de producción especializadas
              </li>
            </div>
            <div class="li col">
              <li class="fading">
                <span
                  v-scroll="handleScroll"
                  data-scroll-class="animated jackInTheBox"
                  data-scroll-button-distance="400"
                  data-scroll-once="true"
                >
                  2.2
                </span>
                Millones de KW ahorrados anualmente en sistemas de iluminación
                LED
              </li>
            </div>
          </ul>
        </div>
      </div>
    </section>

    <!-- Benefits services -->
    <section class="layout-benefits p-5">
      <div class="container layout-benefits__container">
        <div class="row">
          <div class="col">
            <ul class="list-service list-reset">
              <div class="col-6 list-service__item">
                <li class="fading-service">
                  <img src="../../src/assets/images/ic-50-ahorro.svg" alt="" />
                  <div class="fading-service__text">
                    <strong class="blue-text">50% de Ahorro</strong>
                    <p>
                      En el costo de mantenimiento y reposición de letreros
                      luminosos
                    </p>
                  </div>
                </li>
              </div>

              <div class="col-6 list-service__item">
                <li class="fading-service">
                  <img
                    src="../../src/assets/images/ic-100-retorno.svg"
                    alt=""
                  />
                  <div class="fading-service__text">
                    <strong class="blue-text">100% de Retorno</strong>
                    <p>
                      De inversión de dos años promedio por reemplazo de
                      luminarias LED
                    </p>
                  </div>
                </li>
              </div>

              <div class="col-6 list-service__item">
                <li class="fading-service">
                  <img src="../../src/assets/images/ic-60-ahorro.svg" alt="" />
                  <div class="fading-service__text">
                    <strong class="blue-text">60% de Ahorro</strong>
                    <p>
                      Promedio en el consumo de energía eléctrica con luminarias
                      LED
                    </p>
                  </div>
                </li>
              </div>

              <div class="col-6 list-service__item">
                <li class="fading-service">
                  <img src="../../src/assets/images/ic-sin-gastos.svg" alt="" />
                  <div class="fading-service__text">
                    <strong class="blue-text">Sin gastos Operativos</strong>
                    <p>
                      0% en gastos operativos no deseados en la gestión de
                      permisos ambientales para sus proyectos
                    </p>
                  </div>
                </li>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- Company Video -->
    <section class="section-video light--bg-blue">
      <div class="row max-width-md section-title pb-3 pt-6">
        <video-empresa />
      </div>
    </section>

    <!-- Responsability -->
    <section class="responsibility" id="responsibility">
      <div class="page-layout__container page-title pb-0">
        <div class="container">
          <div class="row page-layout__content flex-column">
            <h1>Responsabilidad Social</h1>
            <p>
              Queremos trascender en el compromiso de contribuir al bienestar de
              la sociedad
            </p>
          </div>
        </div>
      </div>
      <div class="container pb-5">
        <div class="row responsibility-row">
          <!-- Colegio Loyola -->
          <div class="col-4 responsibility-col">
            <figure>
              <img
                src="../../src/assets/images/responsabilidad-colegio-loyola.png"
                alt="Fundacion"
              />
            </figure>
            <div class="responsibility-content">
              <strong
                >Torbel apadrina la remodelación de un aula en el Colegio Loyola
                de Santo Domingo</strong
              >
              <p>
                Como parte de nuestro programa educativo, TORBEL apadrina la
                remodelación de un aula en el Colegio Loyola de Santo Domingo,
                apoyando el desafío del nuevo proyecto educativo de esta
                institución y la formación integral en valores.
              </p>
            </div>
          </div>
          <!-- Fundapec -->
          <div class="col-4 responsibility-col">
            <figure>
              <img
                src="../../src/assets/images/responsabilidad-fundapec.png"
                alt="Fundapec"
              />
            </figure>
            <div class="responsibility-content">
              <strong
                >Torbel cubre el 50% del costo total de la carrera de Ingeniería
                de un estudiante meritorio de escasos recursos</strong
              >
              <p>
                Torbel cree en el compromiso de contribuir al bienestar de la
                sociedad que le acoge y apoya la inversión en la educación como
                fundamento para el desarrollo del país. A través del Proyecto de
                “Fundación APEC de Credito Educativo” FUNDAPEC “ Yo Apuesto a
                Ti”.
              </p>
            </div>
          </div>
          <!-- Fundacion -->
          <div class="col-4 responsibility-col">
            <figure>
              <img
                src="../../src/assets/images/responsabilidad-fundacion.png"
                alt="Fundacion"
              />
            </figure>
            <div class="responsibility-content">
              <strong
                >Apoyamos a la Fundación desde el medio a través del suministro
                de Luminarias LED</strong
              >
              <p>
                Como parte del programa de Responsabilidad Ambiental de TORBEL,
                apoyamos a la Fundación Desde El Medio a través del suministro
                de Luminarias LED, en su iniciativa para mejorar la
                infraestructura en el centro de visitantes del Valle del Bao,
                Parque Nacional Jose Armando Bermúdez. Con este aporte,
                esperamos ayudar a facilitar y promover el disfrute de todos de
                este importante parque nacional.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import SectionEmpresa from "@/components/layout/body-sections/section-empresa.vue";
import VideoEmpresa from "@/components/layout/video-empresa.vue";

export default {
  name: "Empresa",
  components: {
    SectionEmpresa,
    VideoEmpresa,
  },
};
</script>
<style lang="scss">
.page-empresa {

  //Team Member
  .team {
    padding: 0 0 100px;

    .team__grid {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .team__member {
      position: relative;
      max-width: 340px;
      width: 100%;
      border: 1px solid #e9ecef;
      border-radius: 3px;
      margin: 10px;
      padding: 15px;

      @media (max-width: 1199px) {
        max-width: 440px;
      }
      @media (max-width: 991px) {
        max-width: 320px;
      }
      @media (max-width: 767px) {
        max-width: 100%;
      }

      &:hover {
        background: #009645;
        color: $white;
      }

      figure {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin: 0px;
      }

      img {
        display: block;
        width: 215px;
        height: 215px;
        border-radius: 50%;
        object-fit: cover;
        border: 2px solid #e9ecef;
      }
    }
    .team__caption {
      padding: 20px;
    }
    .team__name {
      position: relative;
      text-align: center;
      font-weight: 800;
    }
    .team__role {
      display: block;
      font-size: $extra-small-font-size;
      text-align: center;
      margin-top: 15px;
    }
  }

  // Team Numbers
  .our-numbers {
    @extend %flex__align-center;
    min-height: 556.23px;
    height: 100%;
    background: url("../../src/assets/images/bg-our-numbers.png");

    @media (max-width: 767px) {
      padding-top: 50px;
      padding-bottom: 50px;
      background-size: cover;
      background-position: center;
    }

    .our-numbers--title {
      @extend %flex__align-center;
      font-size: $primary-font-size;
      color: $white;
      text-align: center;
    }

    .list-a {
      overflow: hidden;
      list-style: none;
      margin: 44px 0 0;
      padding: 0;
      line-height: 1.6;
      text-align: center;
      display: flex;
      width: 100%;

      @media (max-width: 767px) {
        flex-direction: column;
      }

      .li {
        .fading {
          color: #fafafa;
          display: flex;
          flex-direction: column;
          margin: 0 auto;

          span {
            font-size: 90px;
            font-weight: 800;
            font-family: $primary-font;
          }
        }
      }
    }
  }
  // Saving in Numbers
  .layout-benefits {
    padding: 50px 0 100px;

    .layout-benefits__container {
      @media (max-width: 1199px) {
        max-width: 100%;
      }
    }

    .layout-benefits__title {
      margin: 30px 0 60px;
      text-align: center;
      color: $light--blue;
    }
    .list-service {
      display: flex;
      flex-wrap: wrap;

      @media (max-width: 767px) {
        flex-direction: column;
        margin-top: 0;
      }

      .list-service__item {
        @media (max-width: 767px) {
          max-width: 100%;
          flex: auto;
        }
      }

      .fading-service {
        @extend %flex__align-center;
        padding: 25px 0px;

        @media (max-width: 991px) {
          flex-direction: column;
          text-align: center;
        }

        img {
          @media (min-width: 992px) {
            margin-right: 20px;
          }
        }

        .fading-service__text {
          @media (max-width: 991px) {
            margin-top: 15px;
          }

          strong {
            font-size: $content-font-size;
          }
        }
      }
    }
  }
  // Company Video
  .section-video {
    color: #ffffff;
    padding-bottom: 40px;

    .page-title {
      padding-bottom: 0px;
    }

    .section-title {
      @media (max-width: 549px) {
        padding: 3rem 1rem !important;
      }
    }

    p {
      margin-top: 0px !important;
    }
  }
  // Responsability
  .responsibility {
    z-index: 999;

    @media (max-width: 767px) {
      margin-top: 15px;
    }

    p {
      margin: 20px 0px;
    }

    .responsibility-row {
      @media (max-width: 991px) {
        max-width: 100%;
        display: flex;
        flex-direction: column;
      }

      .responsibility-col {
        @media (max-width: 991px) {
          max-width: 100%;
        }
        @media (max-width: 767px) {
          max-width: 100%;
          flex: auto;
          margin: 15px 0;
        }
        .responsibility-content {
          @media (max-width: 991px) {
            max-width: 100%;
            display: flex;
            margin: 0px 15px;
            flex-direction: column;
          }
        }
      }
    }
  }
}
</style>
